import { render, staticRenderFns } from "./ModalListaFasesExecucao.vue?vue&type=template&id=5e43499d"
import script from "./ModalListaFasesExecucao.vue?vue&type=script&lang=js"
export * from "./ModalListaFasesExecucao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports